import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument], $slug: [String], $draftId: Int, $revisionId: Int, $status: [String]) {
        data: entry(
            siteId: $siteId
            section: "registrationPages"
            slug: $slug
            draftId: $draftId
            revisionId: $revisionId
            status: $status
        ) {
            id
            title
            slug
            status
            ... on default_Entry {
                redirectUrl: universalLink
                preview
                oauth
                pardotFormHandlerUrl
                accountLoginHeading: string
                registerText: html
                signUpText2: html2
                signUpText: string2
                regBottomText
            }
        }
    }
`
